import { render, staticRenderFns } from "./task.vue?vue&type=template&id=5630353e&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=5630353e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630353e",
  null
  
)

export default component.exports